import { PROFILE_KEY } from '../../../../../models/profile/constants'
import { getActionStrReduxUtil } from '../../../../redux/utils/get-action-str'
import { REDUX_ACTION_PREFIX } from '../../../../redux/constants/action'
import { updateProfileAction } from '../../actions/update'
import { MACRONUTRIENT, MACRONUTRIENT_TO_CALORIES_PER_GRAM } from '../../../../meal/constants'
import { getDailyCalorieIntakeGoalProfileSelect } from '../../selectors/get-daily-calorie-intake-goal'
import { balanceDailyMacroIntakeGoalPercentageProfileAction } from '../balance-daily-macro-intake-goal-percentage'
import { updateDailyFatIntakeGoalPercentageProfileAction } from '../update-daily-fat-intake-percentage-goal'

/**
 * @param value
 * @param shouldUpdatePercentage
 * @returns {(function(*, *): void)|*}
 */
export function updateDailyFatIntakeGoalInGramProfileAction ({
  value,
  shouldUpdatePercentage
}) {
  const key = PROFILE_KEY.DAILY_FAT_INTAKE_GOAL_IN_GRAM
  return (dispatch, getState) => {
    dispatch(
      updateProfileAction({
        type: getActionStrReduxUtil(
          REDUX_ACTION_PREFIX.UPDATE,
          key,
          value
        ),
        payload: {
          key,
          value
        }
      })
    )

    if (!shouldUpdatePercentage) {
      return
    }

    const dailyCalorieIntakeGoal = getDailyCalorieIntakeGoalProfileSelect(getState())
    const macro = MACRONUTRIENT.FAT
    const dailyCarbsIntakeGoalInPercentage = (
      value * MACRONUTRIENT_TO_CALORIES_PER_GRAM[macro]
    ) / dailyCalorieIntakeGoal * 100

    dispatch(
      updateDailyFatIntakeGoalPercentageProfileAction({
        value: dailyCarbsIntakeGoalInPercentage
      })
    )

    dispatch(
      balanceDailyMacroIntakeGoalPercentageProfileAction({
        macroThatWasJustUpdated: macro
      })
    )
  }
}
